import { client } from '../../api';
import { RxFilterValues } from '../../types';

export const downloadPrescriptionsTable = async (
  page: number,
  perPage: number,
  search: string,
  filterValues: RxFilterValues,
  sort_by?: string,
  sort_desc: boolean = true,
) => {
  const office_name = filterValues.office;
  const drug_name = filterValues.drug;
  const drug_category = filterValues.drug_category;
  const status = filterValues.status;
  const created_at_start = filterValues.startDate;
  const created_at_end = filterValues.endDate;
  const response = await client.get('/rxs/download', {
    params: {
      page: page + 1,
      per_page: perPage,
      search,
      prescriber_npi: filterValues.prescriber,
      office_name,
      drug_name,
      drug_category,
      status,
      awaiting_office: filterValues.awaitingOffice ? 'true' : 'false',
      awaiting_patient: filterValues.awaitingPatient ? 'true' : 'false',
      overall_status: filterValues.overallStatus,
      created_at_start: created_at_start || undefined,
      created_at_end: created_at_end || undefined,
      sort_by,
      sort_desc,
    },
  });
  return response.data;
};
